import request from '@/utils/request';

// 上传图片
export const uploadFile = (params) => {
  return request({
    url: '/file',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
